import React, { Component } from "react";
import { getUsersApi, exportUsers } from "../../../api/userService";
import Pagination from "../../../components/Pagination/Pagination";
import { withRouter } from "../../../utils/withRouter";
import ActionIconButton from "../../Shared/ActionIconButton";
import { FaEye } from "react-icons/fa";
import { getErrorMessage } from "../../../utils/errorHandler";
import ExportCsvButton from "../../../common/ExportCsvButton";
import FullPageLoader from "../../../common/FullPageLoader";
import EmptyState from "../../../common/EmptyState";

class Users extends Component {
  state = {
    users: [],
    loading: true,
    error: null,
    currentPage: 1,
    itemsPerPage: 10,
    totalItems: 0,
    successMessage: "",
    errorMessage: "",
    selectedStatus: "",
    showStatusModal: false,
    selectedUser: null,

    statusOptions: [
      "ACTIVE",
      "INACTIVE",
      "ARCHIVED",
      "THRASHED",
      "DELETED",
      "PENDING",
      "DISAPPROVED",
    ],
  };

  componentDidMount() {
    this.loadUsers();
  }

  loadUsers = async () => {
    const { currentPage, itemsPerPage } = this.state;

    try {
      this.setState({ loading: true });

      const res = await getUsersApi({
        page: currentPage,
        pageSize: itemsPerPage,
      });

      const users = Array.isArray(res?.data) ? res.data : [];

      this.setState({
        users,
        totalItems: res?.pagination?.totalItems || users.length,
        loading: false,
        error: null,
      });
    } catch (error) {
      alert(getErrorMessage(error));
    } finally {
      this.setState({ loading: false });
    }
  };
  handlePageChange = (page) => {
    this.setState(
      {
        currentPage: page,
      },
      () => {
        this.loadUsers();
      },
    );
  };

  handleView = (user) => {
    if (!user?._id) {
      alert("Invalid user id");
      return;
    }

    this.props.navigate(`/users/admin/view/${user.name}`, {
      state: {
        userId: user._id,
      },
    });
  };

  handleExportUser = async () => {
    try {
      const response = await exportUsers();

      const blob = new Blob([response.data], {
        type: "text/csv",
      });

      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;

      const contentDisposition = response.headers["content-disposition"];

      let fileName = "users.csv";

      if (contentDisposition) {
        const match = contentDisposition.match(/filename="?(.+?)"?$/);
        if (match?.[1]) {
          fileName = match[1];
        }
      }

      link.setAttribute("download", fileName);

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert(getErrorMessage(error));
    }
  };

  render() {
    const {
      users,
      loading,
      error,
      itemsPerPage,
      currentPage,
      totalItems,
      successMessage,
      errorMessage,
    } = this.state;

    if (loading) {
      return <FullPageLoader text="Loading Users..." />;
    }

    if (error) {
      return <p className="text-danger">{error}</p>;
    }

    return (
      <div className="container-fluid p-4 np-users-page">
        {successMessage && <div className="alert alert-success">{successMessage}</div>}

        {errorMessage && <div className="alert alert-danger">{errorMessage}</div>}
        <div className="card p-3">
          {users.length === 0 ? (
            <EmptyState />
          ) : (
            <>
          <div className="d-flex justify-content-end align-items-center mb-3">
            <ExportCsvButton onClick={this.handleExportUser} />
          </div>

          <table className="table table-bordered table-hover">
            <thead className="bg-light">
              <tr>
                <th className="text-dark fw-bold">Sr No</th>
                <th className="text-dark fw-bold">Full Name</th>
                <th className="text-dark fw-bold">Email</th>
                <th className="text-dark fw-bold">Phone</th>
                <th className="text-dark fw-bold">Action</th>
              </tr>
            </thead>

            <tbody>
              {users.map((user, index) => (
                <tr key={user._id || index}>
                  <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>

                  <td>{user.name || "-"}</td>
                  <td>{user.email || "-"}</td>
                  <td>{user.phone || "-"}</td>

                  <td className="text-center">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "8px",
                      }}
                    >
                      <ActionIconButton
                        icon={<FaEye />}
                        label="View"
                        variant="view"
                        onClick={() => this.handleView(user)}
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
            </>
          )}
        </div>

        {users.length > 0 && <Pagination
          totalItems={totalItems}
          itemsPerPage={itemsPerPage}
          currentPage={currentPage}
          onPageChange={this.handlePageChange}
        />}
      </div>
    );
  }
}

export default withRouter(Users);
